import React, { createContext, useContext, useState } from "react";

// Create the context
const AssessmentWalkthroughContext = createContext();

// Create a provider component
export const AssessmentWalkthroughProvider = ({ children }) => {
  const [showWalkthroughDialog, setShowWalkthroughDialog] = useState(false);
  const [showIsMobileWalkthroughDialog, setShowIsMobileWalkthroughDialog] =
    useState(false);
  const [showCheckBox, setShowCheckBox] = useState(true);

  const showOrHideAssessmentWalkthrough = (value) => {
    setShowWalkthroughDialog(value);
  };
  const showOrHideCheckBox = (value) => {
    setShowCheckBox(value);
  };
  const showOrHideBottomBar = (value) => {
    setShowIsMobileWalkthroughDialog(value);
  };

  return (
    <AssessmentWalkthroughContext.Provider
      value={{
        showWalkthroughDialog,
        showCheckBox,
        showOrHideAssessmentWalkthrough,
        showOrHideCheckBox,
        showIsMobileWalkthroughDialog,
        showOrHideBottomBar,
      }}
    >
      {children}
    </AssessmentWalkthroughContext.Provider>
  );
};

export const useAssessmentWalkthrough = () =>
  useContext(AssessmentWalkthroughContext);
